module.exports = __webpack_public_path__ + "img/index_17.9c9adea4.png";